import { render, staticRenderFns } from "./Filter-Reset.vue?vue&type=template&id=c90fe9d6&lang=pug"
import script from "./Filter-Reset.vue?vue&type=script&setup=true&lang=ts"
export * from "./Filter-Reset.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports